/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSidebar } from "../context/SidebarContext";
// import { WhatshappIcon, OpenMenuIcon } from "../icons";
const WhatshappIcon = (_props: any) => null;
const OpenMenuIcon = (_props: any) => null;
import logo from "../assets/logo/logo.png";
import avatar from "../assets/images/user/avatar.png";
import footerLogo from "../assets/logo/logo_footer.png";
import { useNavigation } from "../context/NavigationContext";
import RegisterModal from "../pages/Auth/Register/home";
import LoginModal from "../pages/Auth/Login/home";
import httpService from "../services/httpService";
import { useAuth } from "../context/AuthContext";
import { LogInIcon } from "lucide-react";
import ForgotPasswordModal from "../pages/Auth/ForgotPassword/ForgotPassword";

// Helper component for User Menu (Standard styling for profile dropdown)
const MenuItem = ({
    label,
    onClick,
    danger = false,
}: {
    label: string;
    onClick: () => void;
    danger?: boolean;
}) => (
    <button
        onClick={onClick}
        className={`block w-full text-left px-4 py-2 text-sm transition-colors hover:bg-gray-100 ${danger ? "text-red-600 hover:bg-red-50" : "text-gray-700"
            }`}
    >
        {label}
    </button>
);

const AppHeader: React.FC = () => {
    // Context & State
    const { isExpanded, toggleSidebar, toggleMobileSidebar, isMobileOpen } = useSidebar();
    const { activeNav, setActiveNav } = useNavigation();
    const navigate = useNavigate();
    const location = useLocation();

    // Local State
    const [isApplicationMenuOpen, setApplicationMenuOpen] = useState(false);
    const [hoveredItem, setHoveredItem] = useState<string | null>(null);
    const [isRegisterOpen, setRegisterOpen] = useState(false);
    const [isLoginOpen, setLoginOpen] = useState(false);
    const [isForgotPasswordOpen, setForgotPasswordOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const { user, fetchUser, logout } = useAuth();

    const inputRef = useRef<HTMLInputElement>(null);

    // --- Navigation Logic ---
    const menuRoutes: Record<string, string> = {
        Home: "/",
        Franchise: "/franchise",
        Jobs: "/jobs",
        "Training Center": "/training-center",
        Company: "/company",
        System: "/system",
        "About Us": "/about",
        "Offers Today": "/offers",
        "Dashboard": "/applicant/dashboard",
        Live: "/live",
    };

    const dropdownRoutes: Record<string, string> = {
        Academy: "/training-center/academy",
        Courses: "/training-center/courses",
        "Terms & Conditions": "/company/terms",
        "Privacy Policy": "/company/privacy-policy",
        "Warranty Policy": "/company/warranty-policy",
        "Warranty Claim": "/company/warranty-claim",
        "Meet Our Team": "/company/team",
        "Contact Us": "/company/contact",
        FAQs: "/company/faqs",
        Disclaimer: "/company/disclaimer",
        "Phone Screen": "/system/phone-screen",
        "Part & IC Chip": "/system/part-chip",
        "Access Zone": "/system/access-zone",
        "Counter Order": "/system/counter-order",
        "Official DOC": "/system/official-doc",
        "Latest News": "/live/latest-news",
        Live: "/live",
    };

    const menuItems = [
        "Home",
        "Franchise",
        "Company",
        ...(user ? ["Dashboard"] : ["Jobs"]),
        "About Us",
        "Offers Today",
    ];

    const dropdownItems = {
        Company: [
            "Terms & Conditions",
            "Privacy Policy",
            "Warranty Policy",
            "Warranty Claim",
            "Meet Our Team",
            "Contact Us",
            "FAQs",
            "Disclaimer",
        ],
        Live: ["Live", "Latest News"],
        "Training Center": ["Academy", "Courses"],
        System: ["Phone Screen", "Part & IC Chip", "Acess Zone", "Counter Order", "Official DOS"]
    };

    useEffect(() => {
        const path = location.pathname;

        const matchedMainItem = Object.keys(menuRoutes)
            .sort((a, b) => menuRoutes[b].length - menuRoutes[a].length)
            .find((key) => path.startsWith(menuRoutes[key]));

        if (matchedMainItem) {
            setActiveNav(matchedMainItem);
            return;
        }

        setActiveNav("Home");
    }, [location.pathname]);

    // --- Handlers ---
    const handleToggle = () => {
        const isDesktop = window.innerWidth >= 1440;
        if (isDesktop) toggleSidebar();
        else toggleMobileSidebar();
    };

    const handleMenuClick = (item: string) => {
        if (item === "Dashboard") {
            setActiveNav(item);
            navigate("/applicant/dashboard");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }

        if (dropdownItems[item as keyof typeof dropdownItems]) {
            setHoveredItem(item === hoveredItem ? null : item);
            return;
        }

        const route = menuRoutes[item];
        if (route) {
            setActiveNav(item);
            navigate(route);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleSubMenuClick = (subItem: string) => {
        setActiveNav(subItem);
        const route = dropdownRoutes[subItem];
        if (route) {
            navigate(route);
            window.scrollTo({ top: 0, behavior: "smooth" });
            setHoveredItem(null);
        }
    };

    return (
        <>
            {/* Header with Brand Background Logic */}
            <header className="w-full bg-white dark:bg-gray-900 sticky top-0 shadow z-50 transition-colors duration-300">
                <div className="w-full max-w-7xl mx-auto px-4 sm:px-6">
                    <div className="flex items-center justify-between h-20">

                        {/* --- LEFT SECTION: Mobile Toggle & Logo --- */}
                        <div className="flex items-center gap-4">
                            {/* Mobile Menu Button */}
                            <button
                                className="p-2 -ml-2 rounded-md xl:hidden dark:text-white text-gray-800 hover:bg-gray-500 dark:hover:bg-gray-100 focus:outline-none"
                                onClick={handleToggle}
                            >
                                {isExpanded ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="currentColor" viewBox="0 0 448 512">
                                        <path d="M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z" />
                                    </svg>
                                ) : (
                                    <OpenMenuIcon className="w-6 h-6" />
                                )}
                            </button>

                            {/* Logo */}
                            {/* <img
                                src={isMobileOpen ? footerLogo : logo}
                                alt="logo"
                                className="h-10 w-auto object-contain cursor-pointer transition-opacity"
                                onClick={() => navigate("/")}
                            /> */}
                            <img
                                src={footerLogo}
                                alt="logo"
                                className="h-8 w-auto hidden dark:block object-contain cursor-pointer transition-opacity"
                                onClick={() => navigate("/")}
                            />
                            <img
                                src={logo}
                                alt="logo"
                                className="h-8 w-auto block dark:hidden object-contain cursor-pointer transition-opacity"
                                onClick={() => navigate("/")}
                            />
                        </div>

                        {/* --- MIDDLE SECTION: Desktop Navigation (Centered) --- */}
                        <nav className="hidden xl:flex flex-1 items-center justify-center px-8">
                            <ul className="flex items-center gap-1">
                                {menuItems.map((item) => {
                                    const hasDropdown = !!dropdownItems[item as keyof typeof dropdownItems];
                                    const isActive = activeNav === item && !hasDropdown;
                                    const isHovered = hoveredItem === item;

                                    return (
                                        <li
                                            key={item}
                                            className="relative"
                                            onMouseEnter={() => setHoveredItem(item)}
                                            onMouseLeave={() => setHoveredItem(null)}
                                        >
                                            <button
                                                onClick={() => handleMenuClick(item)}
                                                className={`
                                                    flex items-center gap-1 px-4 py-2 text-sm transition-all duration-200
                                                    ${isActive || isHovered
                                                        ? "brand-text font-semibold bg-gray-100 dark:bg-gray-700 rounded-md" // Active State using brand-text
                                                        : "text-gray-600 hover:text-black dark:text-gray-500 hover:bg-zinc-100 rounded-md"
                                                    }
                                                `}
                                            >
                                                {item}
                                                {hasDropdown && (
                                                    <span className={`text-[10px] ml-0.5 transition-transform duration-200 ${isHovered ? "rotate-180" : ""}`}>
                                                        ▼
                                                    </span>
                                                )}
                                            </button>

                                            {/* Dropdown Menu */}
                                            {hasDropdown && isHovered && (
                                                <div className="absolute left-0 pt-2 w-56 z-[60]">
                                                    {/* pt-2 creates an invisible bridge */}
                                                    <div className="bg-white text-gray-800 shadow-lg rounded-md overflow-hidden ring-1 ring-black ring-opacity-5">
                                                        <ul className="py-0">
                                                            {dropdownItems[item as keyof typeof dropdownItems]?.map((subItem) => (
                                                                <li key={subItem}>
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleSubMenuClick(subItem);
                                                                        }}
                                                                        className={`
                                                                            block w-full text-left px-4 py-2.5 text-sm transition-all duration-200
                                                                            ${activeNav === subItem
                                                                                ? "brand-bg text-white font-semibold" // Brand BG for active dropdown
                                                                                : "bg-white text-gray-800 brand-hover-bg hover:text-white" // Brand Hover effect
                                                                            }
                                                                        `}
                                                                    >
                                                                        {subItem}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </nav>

                        {/* --- RIGHT SECTION: Auth / User --- */}
                        <div className="flex items-center justify-end gap-3 min-w-[140px]">
                            {!user ? (
                                <div className="hidden sm:flex items-center gap-3">
                                    <button
                                        onClick={() => setLoginOpen(true)}
                                        className="text-base font-semibold px-6 py-1.5 rounded-md border brand-text brand-border hover:bg-gray-50 transition-colors"
                                    >
                                        Login
                                    </button>
                                    <button
                                        onClick={() => setRegisterOpen(true)}
                                        className="text-base font-semibold px-6 py-1.5 rounded-md text-white brand-bg hover:opacity-90 shadow-sm transition-all"
                                    >
                                        Register
                                    </button>
                                </div>
                            ) : (
                                <div className="relative">
                                    <button
                                        onClick={() => setIsUserMenuOpen((prev) => !prev)}
                                        className="flex items-center gap-2 p-1 pl-2 pr-3 transition-all"
                                    >
                                        <div className="w-8 h-8 rounded-full brand-bg text-white flex items-center justify-center text-sm font-bold overflow-hidden">
                                            <img
                                                src={user?.profileImage || avatar}
                                                alt="logo"
                                                className=" w-full h-full object-cover cursor-pointer transition-opacity"
                                                onError={(e) => {
                                                    e.currentTarget.src = avatar;
                                                }}
                                            />
                                        </div>
                                        <div className="flex flex-col items-start">
                                            <span className="text-sm font-medium text-gray-700 dark:text-gray-100 max-w-[80px] truncate hidden sm:block">
                                                {user?.fullName}
                                            </span>
                                            <span className="text-xs font-medium text-gray-400 truncate hidden sm:block">Applicant</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                        </svg>
                                    </button>

                                    {/* User Dropdown */}
                                    {isUserMenuOpen && (
                                        <>
                                            <div
                                                className="fixed inset-0 z-40"
                                                onClick={() => setIsUserMenuOpen(false)}
                                            />

                                            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 z-50 py-1">
                                                <div className="px-4 py-1 border-b border-gray-100 sm:hidden">
                                                    <p className="text-sm font-medium text-gray-900 truncate">
                                                        {user?.fullName}
                                                    </p>
                                                    <span className="text-xs font-medium text-gray-400 truncate sm:block">Applicant</span>
                                                </div>

                                                <MenuItem
                                                    label="Dashboard"
                                                    onClick={() => {
                                                        navigate("/applicant/dashboard");
                                                        setIsUserMenuOpen(false)
                                                    }}
                                                />

                                                <MenuItem
                                                    label="Explore Jobs"
                                                    onClick={() => {
                                                        navigate("/applicant/explore");
                                                        setIsUserMenuOpen(false)
                                                    }}
                                                />

                                                <MenuItem
                                                    label="Applied Jobs"
                                                    onClick={() => {
                                                        navigate("/applicant/applied");
                                                        setIsUserMenuOpen(false)
                                                    }}
                                                />

                                                <MenuItem
                                                    label="My Order"
                                                    onClick={() => {
                                                        navigate("/applicant/order");
                                                        setIsUserMenuOpen(false)
                                                    }}
                                                />

                                                <MenuItem
                                                    label="Profile"
                                                    onClick={() => {
                                                        navigate("/applicant/profile");
                                                        setIsUserMenuOpen(false)
                                                    }}
                                                />

                                                <div className="border-t border-gray-100 my-1" />

                                                <MenuItem
                                                    label="Logout"
                                                    danger
                                                    onClick={() => {
                                                        logout();
                                                        navigate("/");
                                                        setIsUserMenuOpen(false);
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}

                                </div>
                            )}

                            {/* Mobile Login Icon */}
                            {!user && (
                                <button onClick={() => setLoginOpen(true)} className="sm:hidden px-2 py-1 dark:text-white text-gray-600 flex gap-2 border border-gray-300 rounded-md">
                                    <LogInIcon className="size-5"/>
                                    <span className="text-sm font-medium">Login</span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* --- MOBILE SEARCH BAR (Restored from your logic) --- */}
                {isApplicationMenuOpen && (
                    <div className="xl:hidden px-4 pb-4 border-t border-gray-100 bg-gray-50">
                        <div className="relative mt-3">
                            <input
                                ref={inputRef}
                                type="text"
                                placeholder="Search..."
                                className="w-full pl-4 pr-4 py-2 border border-gray-300 rounded-full focus:ring-2 brand-border outline-none"
                            />
                        </div>
                        <div className="mt-3 flex justify-between items-center">
                            <a
                                href="https://wa.me/918695864141"
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center gap-2 bg-[#2E3A56] text-white px-4 py-2 rounded-full shadow-md"
                            >
                                <WhatshappIcon className="w-5 h-5 fill-white" />
                                <span className="font-semibold">Call</span>
                            </a>
                        </div>
                    </div>
                )}
            </header>

            <RegisterModal
                isOpen={isRegisterOpen}
                onClose={() => setRegisterOpen(false)}
                onSwitchToLogin={() => {
                    setRegisterOpen(false);
                    setLoginOpen(true);
                }}
            />
            <LoginModal
                isOpen={isLoginOpen}
                onClose={() => setLoginOpen(false)}
                onForgotPassword={() => {
                    setLoginOpen(false);
                    setForgotPasswordOpen(true);
                }}
                onSwitchToRegister={() => {
                    setLoginOpen(false);
                    setRegisterOpen(true);
                }}
                onSuccess={() => {
                    fetchUser();
                    setLoginOpen(false);
                }}
            />
            <ForgotPasswordModal
                isOpen={isForgotPasswordOpen}
                onClose={() => setForgotPasswordOpen(false)}
                onSwitchToLogin={() => {
                    setForgotPasswordOpen(false);
                    setLoginOpen(true);
                }}
            />
        </>
    );
};

export default AppHeader;